export default __webpack_public_path__ + "static/spot-illos-light-bf4410c9fdbc3076906dd4c9bf2b9492db2cfa178edc98a1aad7198765a4b105.png";